import eventHub from 'frontend/_globals/event-hub'
import { dialogsGlobalMethods } from 'frontend/common/layout/dialogs/dialogs.vue'

export const dialogs = dialogsGlobalMethods(eventHub)
